import React from 'react';
import { lazy } from 'react';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import Login from './components/Login';
import ProtectedPages from './ProtectedPages';

import { AUTH_TOKEN } from './Context';


function App() {
  const [authToken, setAuthToken] = useState();
  const [appUserName, setAppUserName] = useState();

  if(!authToken) {
    let savedToken = localStorage.getItem('authToken');
    let savedUserName = localStorage.getItem('username');
    if (savedToken) {
      setAuthToken(savedToken);
      setAppUserName(savedUserName);
    } else {
      return <Login setToken={setAuthToken} setAppUserName={setAppUserName}/>;
    }
  }
  
  let token = "Token " + authToken
  return(
    <AUTH_TOKEN.Provider value={token}>
      <ProtectedPages setAuthToken={setAuthToken} appUserName={appUserName} setAppUserName={setAppUserName}/>
    </AUTH_TOKEN.Provider>
  );
}




export default App;
